import { enStatusInvite } from 'interface/invites';

export interface IInviteState {
  inviteStatus?: enStatusInvite;
  errorStatus?: number;
  successStatus?: Boolean;
}

const initialState: IInviteState = {};

const invite = (state = initialState, action: any) => {
  switch (action.type) {
    case 'RECEIVE_INVITE_STATUS':
      return {
        inviteStatus: action.inviteStatus,
      };

    case 'RECEIVE_ERROR_INVITE_STATUS':
      return {
        errorStatus: action.errorStatus,
      };

    case 'RECEIVE_SUCCESS_INVITE_STATUS':
      return {
        successStatus: action.successStatus,
      };

    default:
      return state;
  }
};

export default invite;
